<template>
  <div class="header">
    <div :class="fixedFlag || showMenu ? 'logo_default' : 'logo_color'" class="logoBox">
      <img :src="fixedFlag || showMenu ? logo_default : logo_color" alt="logo" class="logo" @click="goHome">
      <img v-if="!showMenu" :src="fixedFlag ? menu_default : menu" alt="menu" class="menu" @click="changeMenuShow(true)">
      <van-icon v-else class="cancel" name="cross" @click="changeMenuShow(false)" :style="{color: showMenu ? '#ffffff' : '#000000'}"/>
    </div>
  </div>
</template>
<script>
import logo_default from '@/../static/img/home/logo_default.svg';
import logo_color from '@/../static/img/home/logo_color.svg';
import menu_default from '@/../static/img/home/menu_default.svg';
import menu from '@/../static/img/home/menu.svg';
import Bus from "../bus"
export default {
  name: 'AppHeader',
  data() {
    return {
      logo_default,
      logo_color,
      menu,
      menu_default,
    }
  },
  props: {
    fixedFlag: {
      type: Boolean,
      default: false // 样式是否为默认固定顶部样式
    },
    showMenu: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    goHome() {
      if (this.$route.fullPath != '/') {
        Bus.$emit("logo-fixed-flag", true)
        Bus.$emit("show-menu", false)
        this.$router.push('/')
      }
    },
    changeMenuShow(val) {
      Bus.$emit("show-menu", val);
    }
  }
}
</script>
<style lang="less" scoped>
.header {
  position: fixed;
  z-index: 10000;
  width: 100%;
  height: 96px;
  top: 0;
  left: 0;
  z-index: 9;
  .logoBox {
    position: relative;
    display: flex;
    height: 96px;
    align-items: center;
    justify-content: space-between;
  }
  .logo_default {
    box-shadow: 0px -10px 11px 7px rgb(8 8 77 / 20%);
  }
  .logo_color {
    background: #ffffff;
    box-shadow: 0px -10px 11px 7px rgba(8, 8, 77, 0.2);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    transition: 0.4s;
  }
  .logo {
    width: 228px;
    height: 64px;
    margin-left: 16px;
  }
  .menu {
    margin-right: 24px;
    width: 48px;
    height: 48px;
  }
  .cancel {
    margin-right: 24px;
    font-size: 48px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue